export default __webpack_public_path__ + "static/media/guide4.76f02082.webp";